import $$ from 'cmn-utils'

const baseUrl = "/api/sys/protocol/";
export default {
    lastVersionProtocol: (params) => {
        return $$.get(baseUrl + 'last-version-protocol', params)
    },
    signProtocol: (params) => {
        return $$.post(baseUrl + 'sign-protocol', params)
    },
}